import { SVGProps } from "react";

export const ChatIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 16V8.00001M8 14V10M16 14V10M17 3.33801C15.4806 2.45874 13.7555 1.99712 12 2.00001C6.477 2.00001 2 6.47701 2 12C2 13.6 2.376 15.112 3.043 16.453C3.221 16.809 3.28 17.216 3.177 17.601L2.582 19.827C2.52307 20.0473 2.52312 20.2792 2.58216 20.4995C2.64119 20.7198 2.75712 20.9206 2.91831 21.0819C3.07951 21.2432 3.2803 21.3593 3.50053 21.4184C3.72075 21.4776 3.95267 21.4778 4.173 21.419L6.399 20.823C6.78538 20.7254 7.19414 20.7727 7.548 20.956C8.93095 21.6446 10.4551 22.002 12 22C17.523 22 22 17.523 22 12C22 10.179 21.513 8.47001 20.662 7.00001"
      stroke="url(#paint0_linear_5823_6603)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5823_6603"
        x1="1.58904"
        y1="12"
        x2="11.8465"
        y2="1.79466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
    </defs>
  </svg>
);
